module.exports = __webpack_public_path__ + "assets/pass_ribon.b5a66fb8.svg";